import { Button } from '@arcadiapower/design-system';
import { useTranslation } from 'react-i18next';
import { Provider } from '@schema/schemas';
import { trackEvent, TrackEvents } from '@client/utils/analytics';
import { ty } from '@client/styles/typography';
import { Description, ForgotPasswordLinkWrapper } from './forgot-password-link.style';

export type Props = {
  provider: Provider;
};

export const ForgotPasswordLink = ({ provider }: Props): JSX.Element | null => {
  const { t } = useTranslation('connect', { keyPrefix: 'components.forgotPasswordLink' });
  // Hide if there is no link or if this is a third-party-portal utility
  //
  // Third party portal utilities do not have username/password, so this
  // component does not make sense
  if (!provider.website || provider.isThirdPartyPortalSupported) return null;
  return (
    <ForgotPasswordLinkWrapper>
      <Description className={ty('paragraph400')}>{t('description')}</Description>
      <Button
        variant="link"
        asChild
        className="h-auto rounded-sm p-0"
        onClick={() => trackEvent(TrackEvents.PASSWORD_RESET_LINK_CLICKED)}
      >
        <a href={provider.website} target="_blank" rel="noreferrer">
          {t('linkLabel', { providerName: provider.name })}
        </a>
      </Button>
    </ForgotPasswordLinkWrapper>
  );
};
